import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgNebulaAi = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 248 276",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_f_3699_711)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M97 42C108.12 42.4 118.2 30.27 129.69 28.69C141.18 27.12 153.83 18.35 166 18C182.24 30.03 194.89 47.28 203 65C200.76 42.58 181.29 26.82 165 13C141.53 19.95 117.2 27.74 97 42Z",
					fill: "#31DA8A",
					fillOpacity: .06
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97 42C89.42 41.73 82.75 37.41 75.02 36.98C67.3 36.54 58.85 35.37 52 36C53 36.36 55.04 38.88 55 40C69.77 37.6 83.7 43 98 43C98.5 43 99.5 42.98 100 43C109.11 38.53 120.46 33.44 130.22 30.22C139.98 27.01 154.35 22.33 164.02 22.02C173.7 21.72 182.17 35.59 187.77 42.23C193.37 48.87 201.63 62.59 203 71C203 69 203 67 203 65C194.89 47.28 182.24 30.03 166 18C153.83 18.35 141.18 27.12 129.69 28.69C118.2 30.27 108.12 42.4 97 42Z",
					fill: "#3BDE93",
					fillOpacity: .13
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M100 43C108.56 43.34 122.03 36.24 130 33C138.73 29.45 153.54 23.94 160.25 31.19C166.95 38.45 177.09 43.82 178 53C180.76 49.88 182.8 59.37 184.64 61.7C186.47 64.03 190.7 70.3 190 76C192.97 73.4 192.26 81.1 193.97 85.03C195.69 88.95 194.29 93.3 195 97C178.31 84.88 160.17 74.94 141 68C146.13 70.54 151.8 74.5 157.23 76.77C162.66 79.04 169.1 82.81 173.7 86.3C178.29 89.8 184.49 92.97 188.25 96.75C192.01 100.54 201.19 103.76 203 108C203 95.67 203 83.33 203 71C201.63 62.59 193.37 48.87 187.77 42.23C182.17 35.59 173.7 21.72 164.02 22.02C154.35 22.33 139.98 27.01 130.22 30.22C120.46 33.44 109.11 38.53 100 43Z",
					fill: "#3CE097",
					fillOpacity: .23
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M130 33C132.66 32.51 135.71 33.84 138 32C158.13 46.41 174.5 60.58 179 83C163.58 76.44 148.35 68.35 132 64C134.79 65.1 137.94 66.9 141 68C160.17 74.94 178.31 84.88 195 97C194.29 93.3 195.69 88.95 193.97 85.03C192.26 81.1 192.97 73.4 190 76C190.7 70.3 186.47 64.03 184.64 61.7C182.8 59.37 180.76 49.88 178 53C177.09 43.82 166.95 38.45 160.25 31.19C153.54 23.94 138.73 29.45 130 33Z",
					fill: "#35E295",
					fillOpacity: .28
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M130 33C122.03 36.24 108.56 43.34 100 43C99.5 42.98 98.5 43 98 43C97.77 43.34 98 44 98 44C105.23 42.96 111.24 42.75 118 40C130.05 35.1 141.34 42.21 149.68 49.32C158.03 56.43 165.56 67.53 170 77C161.41 73.38 152.08 70.2 144 66C136.97 64.04 129.46 62.7 123 62C123.74 62.31 124.3 62.59 125 63C126.65 63.13 129.47 63.35 132 64C148.35 68.35 163.58 76.44 179 83C174.5 60.58 158.13 46.41 138 32C135.71 33.84 132.66 32.51 130 33Z",
					fill: "#30E494",
					fillOpacity: .35
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26 47C25.61 48.05 27.91 48.3 26 51C27.47 50.26 28.3 50.09 30 50C33.23 48.69 37.67 46.45 41 45C44.98 43.26 50.8 40.68 55 40C55.04 38.88 53 36.36 52 36C40.65 37.05 34.13 39.41 26 47Z",
					fill: "#1DB79D",
					fillOpacity: .14
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M118 40C134.69 39.4 151.34 57.77 160 70C154.27 70.16 149.64 66.31 144 66C152.08 70.2 161.41 73.38 170 77C165.56 67.53 158.03 56.43 149.68 49.32C141.34 42.21 130.05 35.1 118 40Z",
					fill: "#2FE495",
					fillOpacity: .4
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41 45C42.89 44.68 45.08 45.03 47 45C61.83 44.8 77.17 44.72 92 45C93.67 45.03 95.33 45 97 45C97.26 44.88 97.88 44.26 98 44C98 44 97.77 43.34 98 43C83.7 43 69.77 37.6 55 40C50.8 40.68 44.98 43.26 41 45Z",
					fill: "#3FD79B",
					fillOpacity: .26
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M98 44C97.88 44.26 97.26 44.88 97 45C117.42 45 137.92 46.18 151 65C140.15 62.38 127.85 58.25 117 60C118.98 60.63 121.11 61.22 123 62C129.46 62.7 136.97 64.04 144 66C149.64 66.31 154.27 70.16 160 70C151.34 57.77 134.69 39.4 118 40C111.24 42.75 105.23 42.96 98 44Z",
					fill: "#2FE495",
					fillOpacity: .48
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M47 45C40.63 47.15 37.1 57.49 33.23 62.23C29.36 66.97 25.09 80.32 24.02 86.02C22.96 91.73 18.58 108.29 25 110C25.47 110.12 26 110 26 110C27.63 100.93 36.7 92.62 44.25 87.25C51.8 81.87 60.17 74.65 68 70C57.56 74.5 49.1 83.18 39 88C39.38 75.86 46.86 68.81 54.7 58.7C62.53 48.59 76.05 42.48 90 46C91.26 45.85 91.23 45.24 92 45C77.17 44.72 61.83 44.8 47 45Z",
					fill: "#3FD19E",
					fillOpacity: .38
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97 45C95.33 45 93.67 45.03 92 45C91.23 45.24 91.26 45.85 90 46C89.76 46.2 90 47 90 47C106.77 44.24 127.04 46.28 139 59C130.58 60.37 121.6 56.03 114 59C115 59.26 116.04 59.69 117 60C127.85 58.25 140.15 62.38 151 65C137.92 46.18 117.42 45 97 45Z",
					fill: "#30E497",
					fillOpacity: .58
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30 50C30.95 49.95 33.41 51.46 35 50C34.76 51.88 32.45 51.46 32 53C28.36 62.56 24.78 70.07 20.22 81.22C15.67 92.38 19.32 104.59 24 115C24.13 114.71 25.68 113.99 26 114C25.33 113.04 24.5 111.22 25 110C18.58 108.29 22.96 91.73 24.02 86.02C25.09 80.32 29.36 66.97 33.23 62.23C37.1 57.49 40.63 47.15 47 45C45.08 45.03 42.89 44.68 41 45C37.67 46.45 33.23 48.69 30 50Z",
					fill: "#0FBCA1",
					fillOpacity: .37
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68 70C69.99 69.14 74.56 66.5 76 68C77.58 69.31 77.66 66.98 79 66C68.97 67.14 57.18 73.7 48 79C55.07 63.01 69.77 46.18 89 47C89.5 47 90 47 90 47C90 47 89.76 46.2 90 46C76.05 42.48 62.53 48.59 54.7 58.7C46.86 68.81 39.38 75.86 39 88C49.1 83.18 57.56 74.5 68 70Z",
					fill: "#41DB98",
					fillOpacity: .46
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M90 47C90 47 89.5 47 89 47C76.46 52.92 60.28 57.9 54 73C63.06 71.01 72.48 63.69 81 64C85.13 63.86 86.15 61.42 90 60C82.67 60.49 72.75 61.36 66 62C69.24 59.41 72.58 57.25 76 55C90.13 47.46 104.18 45 120 50C125.11 51.62 131.37 52.78 135 57C125.83 57.66 115.34 55.67 107 58C109.23 58.18 111.86 58.44 114 59C121.6 56.03 130.58 60.37 139 59C127.04 46.28 106.77 44.24 90 47Z",
					fill: "#36E296",
					fillOpacity: .66
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18 57C17.7 57.96 18.01 59.98 18 60C19.96 56.85 22.52 52.75 26 51C27.91 48.3 25.61 48.05 26 47C22.69 50.09 20.41 53.41 18 57Z",
					fill: "#4E97A1",
					fillOpacity: .15
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M79 66C78.52 66.35 80.77 64.18 81 64C72.48 63.69 63.06 71.01 54 73C60.28 57.9 76.46 52.92 89 47C69.77 46.18 55.07 63.01 48 79C57.18 73.7 68.97 67.14 79 66Z",
					fill: "#3CDE96",
					fillOpacity: .55
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M76 55C75.68 55.02 85.67 58.8 90 57C94.33 55.2 101.28 55.45 106 55C110.72 54.55 115.87 50.25 120 50C104.18 45 90.13 47.46 76 55Z",
					fill: "#32E497",
					fillOpacity: .96
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26 51C22.52 52.75 19.96 56.85 18 60C17.59 60.66 17.36 61.35 17 62C20.89 57.34 27.44 56.45 32 53C32.45 51.46 34.76 51.88 35 50C33.41 51.46 30.95 49.95 30 50C28.3 50.09 27.47 50.26 26 51Z",
					fill: "#19A1A1",
					fillOpacity: .35
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M76 55C72.58 57.25 69.24 59.41 66 62C72.75 61.36 82.67 60.49 90 60C95.77 59.62 100.95 57.52 107 58C115.34 55.67 125.83 57.66 135 57C131.37 52.78 125.11 51.62 120 50C115.87 50.25 110.72 54.55 106 55C101.28 55.45 94.33 55.2 90 57C85.67 58.8 75.68 55.02 76 55Z",
					fill: "#36E497",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17 62C16.67 62.6 16.36 63.47 16 64C15.38 66.12 14.77 67.88 14 70C15.16 68.16 20.85 61.3 23.7 62.36C26.55 63.41 20.78 72.41 20 74C18.19 77.7 16.53 84.31 16 88C14.37 99.38 18.24 107.96 20 118C20.93 119.32 23.4 120.56 25 122C25 120.74 25.22 119.24 25 118C24.89 117.37 24.26 115.58 24 115C19.32 104.59 15.67 92.38 20.22 81.22C24.78 70.07 28.36 62.56 32 53C27.44 56.45 20.89 57.34 17 62Z",
					fill: "#21A19F",
					fillOpacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9 74C10.49 71.52 13.99 66.95 16 64C16.36 63.47 16.67 62.6 17 62C17.36 61.35 17.59 60.66 18 60C18.01 59.98 17.7 57.96 18 57C14.5 62.2 11.12 67.8 9 74Z",
					fill: "#557897",
					fillOpacity: .19
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14 70C13.28 71.98 12.93 74.02 12 76C13.01 74.22 16.6 73.4 17 71C18.2 71.67 19.58 72.64 20 74C20.78 72.41 26.55 63.41 23.7 62.36C20.85 61.3 15.16 68.16 14 70Z",
					fill: "#31949C",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M125 63C154.4 75.94 179.83 94.55 203 118C203 114.67 203 111.33 203 108C201.19 103.76 192.01 100.54 188.25 96.75C184.49 92.97 178.29 89.8 173.7 86.3C169.1 82.81 162.66 79.04 157.23 76.77C151.8 74.5 146.13 70.54 141 68C137.94 66.9 134.79 65.1 132 64C129.47 63.35 126.65 63.13 125 63Z",
					fill: "#3BDB8B",
					fillOpacity: .09
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9 74C7.54 78.25 6.8 82.59 6 87C7.12 84.46 10.45 79.32 12 76C12.93 74.02 13.28 71.98 14 70C14.77 67.88 15.38 66.12 16 64C13.99 66.95 10.49 71.52 9 74Z",
					fill: "#537794",
					fillOpacity: .39
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68 70C60.17 74.65 51.8 81.87 44.25 87.25C36.7 92.62 27.63 100.93 26 110C26.1 110.66 26.34 112.41 28 112C38.51 93.04 57.03 79.02 75 68C75 68 75.7 67.75 76 68C74.56 66.5 69.99 69.14 68 70Z",
					fill: "#43D69C",
					fillOpacity: .28
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26 110C26 110 25.47 110.12 25 110C24.5 111.22 25.33 113.04 26 114C26.52 114.74 27.92 114.94 28 116C29.02 114.96 30.88 114.89 32 114C40.07 94.75 61.02 82.59 75 68C57.03 79.02 38.51 93.04 28 112C26.34 112.41 26.1 110.66 26 110Z",
					fill: "#44D196",
					fillOpacity: .12
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12 76C9.83 79.82 10 85.72 9 90C10.34 88 11.71 89.46 12 87C15.29 88.26 9.95 91.1 12 92C12.43 91.05 16.41 87.21 16 88C16.53 84.31 18.19 77.7 20 74C19.58 72.64 18.2 71.67 17 71C16.6 73.4 13.01 74.22 12 76Z",
					fill: "#3E8899",
					fillOpacity: .74
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6 87C4.3 96.29 3.86 108.32 5 118C5.03 117.78 8.71 109.65 7 105C5.29 100.35 8.02 94.21 9 90C10 85.72 9.83 79.82 12 76C10.45 79.32 7.12 84.46 6 87Z",
					fill: "#516F93",
					fillOpacity: .52
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9 90C8.02 94.21 5.29 100.35 7 105C8.71 109.65 5.03 117.78 5 118C6.15 127.73 9.95 141.26 16 149C22.96 157.9 32.15 161.35 40 166C34.63 160.89 30.45 154.54 27 148C26.18 146.46 24.77 144.49 24 143C20.6 139.72 13.93 139.96 13.07 132.93C12.22 125.89 9.68 119.31 9.01 111.99C8.34 104.67 11.03 98.29 12 92C9.95 91.1 15.29 88.26 12 87C11.71 89.46 10.34 88 9 90Z",
					fill: "#517293",
					fillOpacity: .73
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12 92C11.03 98.29 8.34 104.67 9.01 111.99C9.68 119.31 12.22 125.89 13.07 132.93C13.93 139.96 20.6 139.72 24 143C19.82 134.91 21.63 127.25 20 118C18.24 107.96 14.37 99.38 16 88C16.41 87.21 12.43 91.05 12 92Z",
					fill: "#438098",
					fillOpacity: .89
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24 115C24.26 115.58 24.89 117.37 25 118C25.43 118.17 26.58 117.82 27 118C26.99 117.9 27.95 116.05 28 116C27.92 114.94 26.52 114.74 26 114C25.68 113.99 24.13 114.71 24 115Z",
					fill: "#419D9C",
					fillOpacity: .28
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28 116C27.95 116.05 26.99 117.9 27 118C27.26 118.11 27.88 118.74 28 119C29.19 117.87 31.72 117.77 32 117C32.36 116.01 31.4 115.43 32 114C30.88 114.89 29.02 114.96 28 116Z",
					fill: "#428A92",
					fillOpacity: .11
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28 119C28.19 119.41 28 120 28 120C37.26 121.66 37.16 136.14 42.77 143.23C48.38 150.32 53.37 157.65 61.23 162.77C69.09 167.89 78.68 170.49 84 178C73.72 185.23 60.36 185.66 49 184C61.68 190.85 77.09 187.14 89 180C84.02 166.65 66.01 166.01 56.25 154.75C46.49 143.5 37.38 133.13 36 118C34.81 117.89 32.82 118.16 32 117C31.72 117.77 29.19 117.87 28 119Z",
					fill: "#4A6985",
					fillOpacity: .08
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24 143C24.77 144.49 26.18 146.46 27 148C26.14 145.53 25.66 142.59 25 140C23.58 134.44 24.34 129.56 25 124C25.06 123.51 25 122.5 25 122C23.4 120.56 20.93 119.32 20 118C21.63 127.25 19.82 134.91 24 143Z",
					fill: "#407D96",
					fillOpacity: .55
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25 122C25 122.5 25.06 123.51 25 124C25.42 123.34 27.75 122.61 28 122C28.17 121.57 28 120.5 28 120C28 120 28.19 119.41 28 119C27.88 118.74 27.26 118.11 27 118C26.58 117.82 25.43 118.17 25 118C25.22 119.24 25 120.74 25 122Z",
					fill: "#478195",
					fillOpacity: .31
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28 122C36.27 129.92 38.28 145.03 48.25 153.75C58.22 162.47 66.39 171.16 79 175C65.56 188.05 40.17 181.67 28 168C33.63 175.21 40.81 180.67 49 184C60.36 185.66 73.72 185.23 84 178C78.68 170.49 69.09 167.89 61.23 162.77C53.37 157.65 48.38 150.32 42.77 143.23C37.16 136.14 37.26 121.66 28 120C28 120.5 28.17 121.57 28 122Z",
					fill: "#4D6D90",
					fillOpacity: .18
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25 124C24.34 129.56 23.58 134.44 25 140C31.15 154.41 45.32 168.25 59 177C47.56 179.45 34.52 173.47 26 165C26.77 165.93 27.2 167.16 28 168C40.17 181.67 65.56 188.05 79 175C66.39 171.16 58.22 162.47 48.25 153.75C38.28 145.03 36.27 129.92 28 122C27.75 122.61 25.42 123.34 25 124Z",
					fill: "#516A91",
					fillOpacity: .32
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27 148C30.45 154.54 34.63 160.89 40 166C42.4 168.28 45.05 170.67 48 172C38.79 173.98 28.48 163.88 22 160C23.53 162.74 23.07 162.66 26 165C34.52 173.47 47.56 179.45 59 177C45.32 168.25 31.15 154.41 25 140C25.66 142.59 26.14 145.53 27 148Z",
					fill: "#516A90",
					fillOpacity: .43
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22 160C28.48 163.88 38.79 173.98 48 172C45.05 170.67 42.4 168.28 40 166C32.15 161.35 22.96 157.9 16 149C17.27 151.62 19.58 158.14 22 160Z",
					fill: "#4F6B93",
					fillOpacity: .53
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_f_3699_711)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M135.55 227.3C122.762 226.84 111.17 240.79 97.9565 242.607C84.743 244.412 70.1955 254.498 56.2 254.9C37.524 241.066 22.9765 221.228 13.65 200.85C16.226 226.633 38.6165 244.757 57.35 260.65C84.3405 252.658 112.32 243.699 135.55 227.3Z",
					fill: "#31DA8A",
					fillOpacity: .06
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M135.55 227.3C144.267 227.611 151.938 232.579 160.827 233.073C169.705 233.579 179.423 234.925 187.3 234.2C186.15 233.786 183.804 230.888 183.85 229.6C166.865 232.36 150.845 226.15 134.4 226.15C133.825 226.15 132.675 226.173 132.1 226.15C121.624 231.291 108.571 237.144 97.347 240.847C86.123 244.539 69.5975 249.921 58.477 250.277C47.345 250.622 37.6045 234.672 31.1645 227.036C24.7245 219.4 15.2255 203.622 13.65 193.95C13.65 196.25 13.65 198.55 13.65 200.85C22.9765 221.228 37.524 241.066 56.2 254.9C70.1955 254.498 84.743 244.412 97.9565 242.607C111.17 240.79 122.762 226.84 135.55 227.3Z",
					fill: "#3BDE93",
					fillOpacity: .13
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M132.1 226.15C122.256 225.759 106.766 233.924 97.6 237.65C87.5605 241.733 70.529 248.069 62.8125 239.732C55.1075 231.383 43.4465 225.207 42.4 214.65C39.226 218.238 36.88 207.325 34.764 204.645C32.6595 201.966 27.795 194.755 28.6 188.2C25.1845 191.19 26.001 182.335 24.0345 177.816C22.0565 173.308 23.6665 168.305 22.85 164.05C42.0435 177.988 62.9045 189.419 84.95 197.4C79.0505 194.479 72.53 189.925 66.2855 187.315C60.041 184.704 52.635 180.369 47.345 176.355C42.0665 172.33 34.9365 168.685 30.6125 164.338C26.2885 159.979 15.7315 156.276 13.65 151.4C13.65 165.58 13.65 179.771 13.65 193.95C15.2255 203.622 24.7245 219.4 31.1645 227.036C37.6045 234.672 47.345 250.622 58.477 250.277C69.5975 249.921 86.123 244.539 97.347 240.847C108.571 237.144 121.624 231.291 132.1 226.15Z",
					fill: "#3CE097",
					fillOpacity: .23
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.6 237.65C94.541 238.214 91.0335 236.684 88.4 238.8C65.2505 222.229 46.425 205.933 41.25 180.15C58.983 187.694 76.4975 196.998 95.3 202C92.0915 200.735 88.469 198.665 84.95 197.4C62.9045 189.419 42.0435 177.988 22.85 164.05C23.6665 168.305 22.0565 173.308 24.0345 177.816C26.001 182.335 25.1845 191.19 28.6 188.2C27.795 194.755 32.6595 201.966 34.764 204.645C36.88 207.325 39.226 218.238 42.4 214.65C43.4465 225.207 55.1075 231.383 62.8125 239.732C70.529 248.069 87.5605 241.733 97.6 237.65Z",
					fill: "#35E295",
					fillOpacity: .28
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.6 237.65C106.766 233.924 122.256 225.759 132.1 226.15C132.675 226.173 133.825 226.15 134.4 226.15C134.665 225.759 134.4 225 134.4 225C126.086 226.196 119.174 226.438 111.4 229.6C97.5425 235.235 84.559 227.059 74.968 218.882C65.3655 210.706 56.706 197.941 51.6 187.05C61.4785 191.213 72.208 194.87 81.5 199.7C89.5845 201.954 98.221 203.495 105.65 204.3C104.799 203.944 104.155 203.622 103.35 203.15C101.453 203.001 98.2095 202.748 95.3 202C76.4975 196.998 58.983 187.694 41.25 180.15C46.425 205.933 65.2505 222.229 88.4 238.8C91.0335 236.684 94.541 238.214 97.6 237.65Z",
					fill: "#30E494",
					fillOpacity: .35
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M217.2 221.55C217.649 220.343 215.004 220.055 217.2 216.95C215.51 217.801 214.555 217.997 212.6 218.1C208.886 219.607 203.78 222.183 199.95 223.85C195.373 225.851 188.68 228.818 183.85 229.6C183.804 230.888 186.15 233.786 187.3 234.2C200.353 232.993 207.851 230.279 217.2 221.55Z",
					fill: "#1DB79D",
					fillOpacity: .14
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M111.4 229.6C92.2065 230.29 73.059 209.165 63.1 195.1C69.6895 194.916 75.014 199.344 81.5 199.7C72.208 194.87 61.4785 191.213 51.6 187.05C56.706 197.941 65.3655 210.706 74.968 218.882C84.559 227.059 97.5425 235.235 111.4 229.6Z",
					fill: "#2FE495",
					fillOpacity: .4
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M199.95 223.85C197.777 224.218 195.258 223.816 193.05 223.85C175.996 224.08 158.355 224.172 141.3 223.85C139.38 223.816 137.471 223.85 135.55 223.85C135.251 223.988 134.538 224.701 134.4 225C134.4 225 134.665 225.759 134.4 226.15C150.845 226.15 166.865 232.36 183.85 229.6C188.68 228.818 195.373 225.851 199.95 223.85Z",
					fill: "#3FD79B",
					fillOpacity: .26
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M134.4 225C134.538 224.701 135.251 223.988 135.55 223.85C112.067 223.85 88.492 222.493 73.45 200.85C85.9275 203.863 100.073 208.613 112.55 206.6C110.273 205.876 107.824 205.197 105.65 204.3C98.221 203.495 89.5845 201.954 81.5 199.7C75.014 199.344 69.6895 194.916 63.1 195.1C73.059 209.165 92.2065 230.29 111.4 229.6C119.174 226.438 126.086 226.196 134.4 225Z",
					fill: "#2FE495",
					fillOpacity: .48
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M193.05 223.85C200.376 221.378 204.435 209.487 208.886 204.036C213.336 198.585 218.247 183.232 219.477 176.677C220.696 170.111 225.733 151.067 218.35 149.1C217.81 148.962 217.2 149.1 217.2 149.1C215.326 159.531 204.895 169.087 196.213 175.263C187.53 181.45 177.905 189.753 168.9 195.1C180.906 189.925 190.635 179.943 202.25 174.4C201.813 188.361 193.211 196.469 184.195 208.095C175.191 219.722 159.643 226.748 143.6 222.7C142.151 222.873 142.186 223.574 141.3 223.85C158.355 224.172 175.996 224.08 193.05 223.85Z",
					fill: "#3FD19E",
					fillOpacity: .38
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M135.55 223.85C137.471 223.85 139.38 223.816 141.3 223.85C142.186 223.574 142.151 222.873 143.6 222.7C143.876 222.47 143.6 221.55 143.6 221.55C124.315 224.724 101.004 222.378 87.25 207.75C96.933 206.175 107.26 211.166 116 207.75C114.85 207.451 113.654 206.957 112.55 206.6C100.073 208.613 85.9275 203.863 73.45 200.85C88.492 222.493 112.067 223.85 135.55 223.85Z",
					fill: "#30E497",
					fillOpacity: .58
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M212.6 218.1C211.508 218.158 208.679 216.421 206.85 218.1C207.126 215.938 209.783 216.421 210.3 214.65C214.486 203.656 218.603 195.02 223.847 182.197C229.08 169.363 224.882 155.322 219.5 143.35C219.351 143.684 217.568 144.512 217.2 144.5C217.971 145.604 218.925 147.697 218.35 149.1C225.733 151.067 220.696 170.111 219.477 176.677C218.247 183.232 213.336 198.585 208.886 204.036C204.435 209.487 200.376 221.378 193.05 223.85C195.258 223.816 197.777 224.218 199.95 223.85C203.78 222.183 208.886 219.607 212.6 218.1Z",
					fill: "#0FBCA1",
					fillOpacity: .37
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M168.9 195.1C166.612 196.089 161.356 199.125 159.7 197.4C157.883 195.894 157.791 198.573 156.25 199.7C167.785 198.389 181.343 190.845 191.9 184.75C183.77 203.139 166.865 222.493 144.75 221.55C144.175 221.55 143.6 221.55 143.6 221.55C143.6 221.55 143.876 222.47 143.6 222.7C159.643 226.748 175.191 219.722 184.195 208.095C193.211 196.469 201.813 188.361 202.25 174.4C190.635 179.943 180.906 189.925 168.9 195.1Z",
					fill: "#41DB98",
					fillOpacity: .46
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M143.6 221.55C143.6 221.55 144.175 221.55 144.75 221.55C159.171 214.742 177.778 209.015 185 191.65C174.581 193.939 163.748 202.357 153.95 202C149.201 202.161 148.028 204.967 143.6 206.6C152.03 206.037 163.438 205.036 171.2 204.3C167.474 207.279 163.633 209.763 159.7 212.35C143.451 221.021 127.293 223.85 109.1 218.1C103.224 216.237 96.0245 214.903 91.85 210.05C102.396 209.291 114.459 211.58 124.05 208.9C121.486 208.693 118.461 208.394 116 207.75C107.26 211.166 96.933 206.175 87.25 207.75C101.004 222.378 124.315 224.724 143.6 221.55Z",
					fill: "#36E296",
					fillOpacity: .66
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M226.4 210.05C226.745 208.946 226.389 206.623 226.4 206.6C224.146 210.223 221.202 214.938 217.2 216.95C215.004 220.055 217.649 220.343 217.2 221.55C221.007 217.997 223.629 214.179 226.4 210.05Z",
					fill: "#4E97A1",
					fillOpacity: .15
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M156.25 199.7C156.802 199.298 154.215 201.793 153.95 202C163.748 202.357 174.581 193.939 185 191.65C177.778 209.015 159.171 214.742 144.75 221.55C166.865 222.493 183.77 203.139 191.9 184.75C181.343 190.845 167.785 198.389 156.25 199.7Z",
					fill: "#3CDE96",
					fillOpacity: .55
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M159.7 212.35C160.068 212.327 148.58 207.98 143.6 210.05C138.621 212.12 130.628 211.833 125.2 212.35C119.772 212.868 113.85 217.813 109.1 218.1C127.293 223.85 143.451 221.021 159.7 212.35Z",
					fill: "#32E497",
					fillOpacity: .96
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M217.2 216.95C221.202 214.938 224.146 210.223 226.4 206.6C226.872 205.841 227.136 205.048 227.55 204.3C223.077 209.659 215.544 210.683 210.3 214.65C209.783 216.421 207.126 215.938 206.85 218.1C208.679 216.421 211.508 218.158 212.6 218.1C214.555 217.997 215.51 217.801 217.2 216.95Z",
					fill: "#19A1A1",
					fillOpacity: .35
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M159.7 212.35C163.633 209.763 167.474 207.279 171.2 204.3C163.438 205.036 152.03 206.037 143.6 206.6C136.965 207.037 131.008 209.452 124.05 208.9C114.459 211.58 102.396 209.291 91.85 210.05C96.0245 214.903 103.224 216.237 109.1 218.1C113.85 217.813 119.772 212.868 125.2 212.35C130.628 211.833 138.621 212.12 143.6 210.05C148.58 207.98 160.068 212.327 159.7 212.35Z",
					fill: "#36E497",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M227.55 204.3C227.93 203.61 228.286 202.61 228.7 202C229.413 199.562 230.115 197.538 231 195.1C229.666 197.216 223.123 205.105 219.845 203.886C216.568 202.679 223.203 192.329 224.1 190.5C226.182 186.245 228.091 178.644 228.7 174.4C230.575 161.313 226.124 151.446 224.1 139.9C223.031 138.382 220.19 136.956 218.35 135.3C218.35 136.749 218.097 138.474 218.35 139.9C218.477 140.625 219.201 142.683 219.5 143.35C224.882 155.322 229.08 169.363 223.847 182.197C218.603 195.02 214.486 203.656 210.3 214.65C215.544 210.683 223.077 209.659 227.55 204.3Z",
					fill: "#21A19F",
					fillOpacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M236.75 190.5C235.037 193.352 231.012 198.608 228.7 202C228.286 202.61 227.93 203.61 227.55 204.3C227.136 205.048 226.872 205.841 226.4 206.6C226.389 206.623 226.745 208.946 226.4 210.05C230.425 204.07 234.312 197.63 236.75 190.5Z",
					fill: "#557897",
					fillOpacity: .19
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M231 195.1C231.828 192.823 232.231 190.477 233.3 188.2C232.139 190.247 228.01 191.19 227.55 193.95C226.17 193.18 224.583 192.064 224.1 190.5C223.203 192.329 216.568 202.679 219.845 203.886C223.123 205.105 229.666 197.216 231 195.1Z",
					fill: "#31949C",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M103.35 203.15C69.54 188.269 40.2955 166.868 13.65 139.9C13.65 143.73 13.65 147.571 13.65 151.4C15.7315 156.276 26.2885 159.979 30.6125 164.338C34.9365 168.685 42.0665 172.33 47.345 176.355C52.635 180.369 60.041 184.704 66.2855 187.315C72.53 189.925 79.0505 194.479 84.95 197.4C88.469 198.665 92.0915 200.735 95.3 202C98.2095 202.748 101.453 203.001 103.35 203.15Z",
					fill: "#3BDB8B",
					fillOpacity: .09
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M236.75 190.5C238.429 185.613 239.28 180.622 240.2 175.55C238.912 178.471 235.083 184.382 233.3 188.2C232.231 190.477 231.828 192.823 231 195.1C230.115 197.538 229.413 199.562 228.7 202C231.012 198.608 235.037 193.352 236.75 190.5Z",
					fill: "#537794",
					fillOpacity: .39
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M168.9 195.1C177.905 189.753 187.53 181.45 196.213 175.263C204.895 169.087 215.326 159.531 217.2 149.1C217.085 148.341 216.809 146.329 214.9 146.8C202.814 168.604 181.516 184.727 160.85 197.4C160.85 197.4 160.045 197.688 159.7 197.4C161.356 199.125 166.612 196.089 168.9 195.1Z",
					fill: "#43D69C",
					fillOpacity: .28
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M217.2 149.1C217.2 149.1 217.81 148.962 218.35 149.1C218.925 147.697 217.971 145.604 217.2 144.5C216.602 143.649 214.992 143.419 214.9 142.2C213.727 143.396 211.588 143.477 210.3 144.5C201.02 166.638 176.927 180.622 160.85 197.4C181.516 184.727 202.814 168.604 214.9 146.8C216.809 146.329 217.085 148.341 217.2 149.1Z",
					fill: "#44D196",
					fillOpacity: .12
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M233.3 188.2C235.796 183.807 235.6 177.022 236.75 172.1C235.209 174.4 233.634 172.721 233.3 175.55C229.517 174.101 235.658 170.835 233.3 169.8C232.806 170.893 228.229 175.309 228.7 174.4C228.091 178.644 226.182 186.245 224.1 190.5C224.583 192.064 226.17 193.18 227.55 193.95C228.01 191.19 232.139 190.247 233.3 188.2Z",
					fill: "#3E8899",
					fillOpacity: .74
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M240.2 175.55C242.155 164.867 242.661 151.032 241.35 139.9C241.316 140.153 237.084 149.503 239.05 154.85C241.017 160.198 237.877 167.259 236.75 172.1C235.6 177.022 235.796 183.807 233.3 188.2C235.083 184.382 238.912 178.471 240.2 175.55Z",
					fill: "#516F93",
					fillOpacity: .52
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M236.75 172.1C237.877 167.259 241.017 160.198 239.05 154.85C237.084 149.503 241.316 140.153 241.35 139.9C240.028 128.711 235.658 113.151 228.7 104.25C220.696 94.0151 210.128 90.0476 201.1 84.7001C207.276 90.5766 212.083 97.8791 216.05 105.4C216.993 107.171 218.615 109.437 219.5 111.15C223.41 114.922 231.081 114.646 232.07 122.731C233.047 130.827 235.968 138.394 236.739 146.812C237.509 155.23 234.416 162.567 233.3 169.8C235.658 170.835 229.517 174.101 233.3 175.55C233.634 172.721 235.209 174.4 236.75 172.1Z",
					fill: "#517293",
					fillOpacity: .73
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M233.3 169.8C234.416 162.567 237.509 155.23 236.739 146.812C235.968 138.394 233.047 130.827 232.07 122.731C231.081 114.646 223.41 114.922 219.5 111.15C224.307 120.454 222.226 129.263 224.1 139.9C226.124 151.446 230.575 161.313 228.7 174.4C228.229 175.309 232.806 170.893 233.3 169.8Z",
					fill: "#438098",
					fillOpacity: .89
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M219.5 143.35C219.201 142.683 218.477 140.625 218.35 139.9C217.856 139.705 216.533 140.107 216.05 139.9C216.062 140.015 214.958 142.143 214.9 142.2C214.992 143.419 216.602 143.649 217.2 144.5C217.568 144.512 219.351 143.684 219.5 143.35Z",
					fill: "#419D9C",
					fillOpacity: .28
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M214.9 142.2C214.958 142.143 216.062 140.015 216.05 139.9C215.751 139.774 215.038 139.049 214.9 138.75C213.532 140.05 210.622 140.165 210.3 141.05C209.886 142.189 210.99 142.856 210.3 144.5C211.588 143.477 213.727 143.396 214.9 142.2Z",
					fill: "#428A92",
					fillOpacity: .11
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M214.9 138.75C214.682 138.279 214.9 137.6 214.9 137.6C204.251 135.691 204.366 119.039 197.915 110.886C191.463 102.732 185.725 94.3026 176.686 88.4146C167.647 82.5266 156.618 79.5366 150.5 70.9001C162.322 62.5856 177.686 62.0911 190.75 64.0001C176.168 56.1226 158.447 60.3891 144.75 68.6001C150.477 83.9526 171.189 84.6886 182.413 97.6376C193.637 110.575 204.113 122.501 205.7 139.9C207.069 140.027 209.357 139.716 210.3 141.05C210.622 140.165 213.532 140.05 214.9 138.75Z",
					fill: "#4A6985",
					fillOpacity: .08
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M219.5 111.15C218.615 109.437 216.993 107.171 216.05 105.4C217.039 108.241 217.591 111.622 218.35 114.6C219.983 120.994 219.109 126.606 218.35 133C218.281 133.564 218.35 134.725 218.35 135.3C220.19 136.956 223.031 138.382 224.1 139.9C222.226 129.263 224.307 120.454 219.5 111.15Z",
					fill: "#407D96",
					fillOpacity: .55
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.35 135.3C218.35 134.725 218.281 133.564 218.35 133C217.867 133.759 215.188 134.599 214.9 135.3C214.705 135.795 214.9 137.025 214.9 137.6C214.9 137.6 214.682 138.279 214.9 138.75C215.038 139.049 215.751 139.774 216.05 139.9C216.533 140.107 217.856 139.705 218.35 139.9C218.097 138.474 218.35 136.749 218.35 135.3Z",
					fill: "#478195",
					fillOpacity: .31
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M214.9 135.3C205.39 126.192 203.078 108.816 191.613 98.7876C180.147 88.7596 170.752 78.7661 156.25 74.3501C171.706 59.3426 200.905 66.6796 214.9 82.4001C208.426 74.1086 200.169 67.8296 190.75 64.0001C177.686 62.0911 162.322 62.5856 150.5 70.9001C156.618 79.5366 167.647 82.5266 176.686 88.4146C185.725 94.3026 191.463 102.732 197.915 110.886C204.366 119.039 204.251 135.691 214.9 137.6C214.9 137.025 214.705 135.795 214.9 135.3Z",
					fill: "#4D6D90",
					fillOpacity: .18
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.35 133C219.109 126.606 219.983 120.994 218.35 114.6C211.278 98.0286 194.982 82.1126 179.25 72.0501C192.406 69.2326 207.402 76.1096 217.2 85.8501C216.315 84.7806 215.82 83.3661 214.9 82.4001C200.905 66.6796 171.706 59.3426 156.25 74.3501C170.752 78.7661 180.147 88.7596 191.613 98.7876C203.078 108.816 205.39 126.192 214.9 135.3C215.188 134.599 217.867 133.759 218.35 133Z",
					fill: "#516A91",
					fillOpacity: .32
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M216.05 105.4C212.083 97.8791 207.276 90.5766 201.1 84.7001C198.34 82.0781 195.293 79.3296 191.9 77.8001C202.492 75.5231 214.348 87.1381 221.8 91.6001C220.041 88.4491 220.57 88.5411 217.2 85.8501C207.402 76.1096 192.406 69.2326 179.25 72.0501C194.982 82.1126 211.278 98.0286 218.35 114.6C217.591 111.622 217.039 108.241 216.05 105.4Z",
					fill: "#516A90",
					fillOpacity: .43
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M221.8 91.6001C214.348 87.1381 202.492 75.5231 191.9 77.8001C195.293 79.3296 198.34 82.0781 201.1 84.7001C210.128 90.0476 220.696 94.0151 228.7 104.25C227.24 101.237 224.583 93.7391 221.8 91.6001Z",
					fill: "#4F6B93",
					fillOpacity: .53
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_f_3699_711",
			x: 0,
			y: 0,
			width: 208,
			height: 208,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 2,
					result: "effect1_foregroundBlur_3699_711"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_f_3699_711",
			x: 7.9,
			y: 36.4001,
			width: 239.2,
			height: 239.2,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 2.3,
					result: "effect1_foregroundBlur_3699_711"
				})
			]
		})] })
	]
});
export default SvgNebulaAi;
